import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BrandMatrixIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-matrix",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 3h-1v18h1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 21h1v-18h-1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 9v6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 15v-3.5a2.5 2.5 0 1 0 -5 0v.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 15v-3.5a2.5 2.5 0 1 0 -5 0v.5"
    }, null), _createTextVNode(" ")]);
  }
};